import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { AdminUsersScreen } from './screens/Admin/AdminUsersScreen'
import { AdminSchoolsScreen } from './screens/Admin/AdminSchoolsScreen'
import { AdminDebugSAKScreen } from './screens/Admin/AdminDebugSAKScreen'
import { AliceScreen } from './screens/Campaigns/AliceScreen'
import { ActivityScreen } from './screens/Account/activity/ActivityScreen'
import { AmplifierScreen } from './screens/AmplifierScreen'
import { AmbassadorSurveyScreen } from './screens/AmbassadorSurveyScreen'
import { BeUnderstoodScreen } from './screens/BeUnderstoodScreen'
import { BusinessOverviewScreen } from './screens/BusinessOverview/BusinessOverviewScreen'
import { CommunityScreen } from './screens/CommunityScreen'
import { CheckoutCallbackScreen } from './screens/Pricing/CheckoutCallbackScreen'
import { CheckoutRedirectScreen } from './screens/Pricing/CheckoutRedirectScreen'
import { CheckoutUnlimitedScreen } from './screens/Pricing/CheckoutUnlimitedScreen'
import { CheckoutSchoolsScreen } from './screens/Pricing/CheckoutSchoolsScreen'
import { CheckoutSchoolsThanksScreen } from './screens/Pricing/CheckoutSchoolsThanksScreen'
import { ContactScreen } from './screens/ContactScreen'
import { DevelopersScreen } from './screens/DevelopersScreen'
import { DiagnosticsScreen } from './screens/DiagnosticsScreen'
import { DataSecurityPolicyScreen } from './screens/DataSecurityPolicyScreen'
import { DemoVideosScreen } from './screens/DemoVideosScreen'
import { ELAScreen } from './screens/ELAScreen'
import { ElementaryScreen } from './screens/ElementaryScreen'
import { GmailScreen } from './screens/GmailScreen'
import { GoogleTrainersScreen } from './screens/GoogleTrainersScreen'
import { HistoryAnnotationScreen } from './screens/HistoryAnnotationScreen'
import { LabsSchoolSearchScreen } from './screens/Labs/LabsSchoolSearchScreen'
import { LabsScreen } from './screens/Labs/LabsScreen'
import { LanguagesScreen } from './screens/LanguagesScreen'
import { AuthScreen } from './screens/Login/AuthScreen'
import { MusicScreen } from './screens/MusicScreen'
import { MyEdTechBundleScreen } from './screens/Campaigns/MyEdTechBundleScreen'
import { MonicaScreen } from './screens/Campaigns/MonicaScreen'
import { MoteLandingScreen } from './screens/MoteLanding/MoteLandingScreen'
import { PilotPreSurveyScreen } from './screens/PilotPreSurveyScreen'
import { PleasedScreen } from './screens/PleasedScreen'
import { PrivacyScreen } from './screens/PrivacyScreen'
import { PricingScreen } from './screens/Pricing/PricingScreen'
import { PrivacyCenterScreen } from './screens/PrivacyCenterScreen'
import { PurpleZaScreen } from './screens/Campaigns/PurpleZaScreen'
import { ShiftingSchoolsCampaign } from './screens/Campaigns/ShiftingScreen'
import { SpringCUEScreen } from './screens/Campaigns/SpringCUEScreen'
import { ShakeUpScreen } from './screens/Campaigns/ShakeUpScreen'
import { SchoolsInfoScreen } from './screens/SchoolsInfoScreen'
import { STEMScreen } from './screens/STEMScreen'
import { StemUpgradeScreen } from './screens/StemUpgradeScreen'
import { StudentUpgradesScreen } from './screens/StudentUpgradesScreen'
import { SlideProbeScreen } from './screens/SlideProbeScreen'
import { SurveyScreen } from './screens/SurveyScreen'
import { TeamsScreen } from './screens/TeamsScreen'
import { TOSScreen } from './screens/TOSScreen'
import { UninstalledScreen } from './screens/UninstalledScreen'
import { UtbScreen } from './screens/Campaigns/UtbScreen'
import { UKWebinarsScreen } from './screens/UKWebinarsScreen'
import { WebinarsScreen } from './screens/WebinarsScreen'
import { WebinarFeedbackScreen } from './screens/WebinarFeedbackScreen'
import { OnboardingScreen } from './screens/Onboarding/OnboardingScreen'
import { DefaultScreen } from './screens/DefaultScreen'
import { HelpAndSupport } from './screens/Dashboard/HelpAndSupport'

import {
  CAREERS_URL,
  CWS_URL,
  FEEDBACK_URL,
  FETC_URL,
  HUB_URL,
  PRESS_URL,
  MOTECE_URL,
  MOTECON_URL,
  STATUS_URL,
  SUBPROCESSOR_URL,
  TAW_URL,
  IOS_STORE_URL,
  WEATHERS_URL
} from '@mote/helpers/constants'

import { AccountRouter } from './screens/Account/AccountRouter'
import { EmbedScreen } from './screens/EmbedScreen'

export const WebRouting = () => {
  return (
    <Switch>
      <Route exact path='/' component={DefaultScreen} />
      <Redirect
        exact
        from='/account/users/0'
        to={{
          pathname: '/account/users',
          search: '?page=0'
        }}
      />
      <Redirect exact from='/activity' to='/account/activity' />
      {/* routes /account/activity must be on top of /account AccountRouter*/}
      <Route exact path='/account/activity' component={ActivityScreen} />
      <Route
        exact
        path='/account/activity/:pageIndex'
        component={ActivityScreen}
      />
      <Route path='/account' component={AccountRouter} />
      <Route exact path='/alice' component={AliceScreen} />
      <Redirect exact from='/admin' to='/admin/debugSAK' />
      <Route exact path='/admin/users' component={AdminUsersScreen} />
      <Route exact path='/admin/schools' component={AdminSchoolsScreen} />
      <Route exact path='/admin/debugSAK' component={AdminDebugSAKScreen} />
      <Route exact path='/diagnostics' component={DiagnosticsScreen} />
      <Route exact path='/amplifier' component={AmplifierScreen} />
      <Route exact path='/beunderstood' component={BeUnderstoodScreen} />
      <Route exact path='/business' component={BusinessOverviewScreen} />
      <Route exact path='/classtechtips' component={MonicaScreen} />
      <Route exact path='/checkout' component={PricingScreen} />
      <Route
        exact
        path='/checkout/callback'
        component={CheckoutCallbackScreen}
      />
      <Route
        exact
        path='/checkout/redirect'
        component={CheckoutRedirectScreen}
      />
      <Route exact path='/pricing' component={PricingScreen} />
      <Route
        exact
        path='/checkout/unlimited'
        component={CheckoutUnlimitedScreen}
      />
      <Route exact path='/checkout/schools' component={CheckoutSchoolsScreen} />
      <Route
        exact
        path='/checkout/schools/thanks'
        component={CheckoutSchoolsThanksScreen}
      />
      <Route exact path='/quote' component={CheckoutSchoolsScreen} />
      <Route exact path='/community' component={CommunityScreen} />
      <Route exact path='/contact' component={ContactScreen} />
      <Route exact path='/demovideos' component={DemoVideosScreen} />
      <Route exact path='/ela' component={ELAScreen} />
      <Route exact path='/elementary' component={ElementaryScreen} />
      <Route exact path='/gmail' component={GmailScreen} />
      <Route
        exact
        path='/shiftingschools'
        component={ShiftingSchoolsCampaign}
      />
      <Route exact path='/developers' component={DevelopersScreen} />
      <Route exact path='/purpleza' component={PurpleZaScreen} />
      <Route exact path='/springCUE' component={SpringCUEScreen} />
      <Route exact path='/shakeuplearning' component={ShakeUpScreen} />
      <Route
        exact
        path='/ambassadorsurvey'
        component={AmbassadorSurveyScreen}
      />
      <Route exact path='/googletrainers' component={GoogleTrainersScreen} />
      <Route
        exact
        path='/historyannotation'
        component={HistoryAnnotationScreen}
      />
      <Route exact path='/labs' component={LabsScreen} />
      <Route exact path='/embed/:id' component={EmbedScreen} />
      <Route
        exact
        path='/labs/schoolsearch'
        component={LabsSchoolSearchScreen}
      />
      <Route exact path='/languages' component={LanguagesScreen} />
      <Route exact path='/login' component={AuthScreen} />
      <Route exact path='/signup' component={AuthScreen} />
      <Route exact path='/music' component={MusicScreen} />
      <Route exact path='/pilotpresurvey' component={PilotPreSurveyScreen} />
      <Route exact path='/myedtechbundle' component={MyEdTechBundleScreen} />
      <Route exact path='/pleased' component={PleasedScreen} />
      <Route exact path='/privacy' component={PrivacyScreen} />
      <Route
        exact
        path='/privacy/dataSecurity'
        component={DataSecurityPolicyScreen}
      />
      <Route exact path='/privacycenter' component={PrivacyCenterScreen} />
      <Route exact path='/schools' component={SchoolsInfoScreen} />
      <Route exact path='/schoolsinfo' component={SchoolsInfoScreen} />
      <Route exact path='/stem' component={STEMScreen} />
      <Route exact path='/stemupgrade' component={StemUpgradeScreen} />
      <Route exact path='/studentupgrades' component={StudentUpgradesScreen} />
      <Route exact path='/support/testSlides' component={SlideProbeScreen} />
      <Route exact path='/survey' component={SurveyScreen} />
      <Route exact path='/example/report' component={SurveyScreen} />
      <Route exact path='/teams' component={TeamsScreen} />
      <Route exact path='/tos' component={TOSScreen} />
      <Route exact path='/uninstalled' component={UninstalledScreen} />
      <Route exact path='/UTB' component={UtbScreen} />
      <Route exact path='/webinars' component={WebinarsScreen} />
      <Route exact path='/UKwebinars' component={UKWebinarsScreen} />
      <Route exact path='/webinarfeedback' component={WebinarFeedbackScreen} />
      <Route path='/m/:moteId' component={MoteLandingScreen} />
      <Route path='/r/:referrerCode' component={AuthScreen} />
      <Route path='/onboarding' component={OnboardingScreen} />
      <Route path='/onboarding/invitation' component={OnboardingScreen} />
      <Route path='/onboarding/survey' component={OnboardingScreen} />
      <Route path='/onboarding/upsell' component={OnboardingScreen} />
      <Route path='/help-support' component={HelpAndSupport} />
      <Route
        path='/chrome'
        component={() => {
          window.location.href = CWS_URL
          return null
        }}
      />
      <Route
        path='/the-hub'
        component={() => {
          window.location.href = HUB_URL
          return null
        }}
      />
      <Route
        path='/taw'
        component={() => {
          window.location.href = TAW_URL
          return null
        }}
      />
      <Route
        path='/feedback'
        component={() => {
          window.location.href = FEEDBACK_URL
          return null
        }}
      />
      <Route
        path='/ios'
        component={() => {
          window.location.href = IOS_STORE_URL
          return null
        }}
      />
      <Route
        path='/status'
        component={() => {
          window.location.href = STATUS_URL
          return null
        }}
      />
      <Route
        path='/careers'
        component={() => {
          window.location.href = CAREERS_URL
          return null
        }}
      />
      <Route
        path='/fetc'
        component={() => {
          window.location.href = FETC_URL
          return null
        }}
      />
      <Route
        path='/impact'
        component={() => {
          window.location.href = WEATHERS_URL
          return null
        }}
      />
      <Route
        path='/motecon'
        component={() => {
          window.location.href = MOTECON_URL
          return null
        }}
      />
      <Route
        path='/motece'
        component={() => {
          window.location.href = MOTECE_URL
          return null
        }}
      />
      <Route
        path='/press'
        component={() => {
          window.location.href = PRESS_URL
          return null
        }}
      />
      <Route
        path='/subprocessors'
        component={() => {
          window.location.href = SUBPROCESSOR_URL
          return null
        }}
      />
      <Route component={DefaultScreen} /> {/* Default if not found */}
    </Switch>
  )
}
